import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';

import MyProfilePage from '../../../subsreens/gcstudent/myprofile/MyProfilepage';

const Profile = () => {
    return(
        <StudentDashboardLayout>
            <MyProfilePage></MyProfilePage>
        </StudentDashboardLayout>
    )
}

export default Profile;